import { React, Fragment, useState } from "react";
import { BrowserRouter as Router, Link, useLocation, useHistory } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import RequestDOIModal from "./Modals/requestDOIModal";
import DeleteProjectModal from "./Modals/deleteProjectModal";

import { HiOutlineDotsHorizontal } from "react-icons/hi";

export default function Project({ userProfile, project, removeProject, requestDOI,setProjectData }) {
  const [openDOIModal, setOpenDOIModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState();
  const [openAddAttachmentModal, setOpenAddAttachmentModal] = useState(false);
  let history = useHistory();

  const updateProjectData = (updatedData) => {
    // Assuming 'project' is the state you want to update
    setProjectData({ ...project, ...updatedData });
  };

  function truncateString(str, newLength) {
    if (str.length <= newLength) {
      return str;
    }
    const subString = str.slice(0, newLength - 1);
    return subString.slice(0, subString.lastIndexOf(" ")) + "\u2026";
  }

  /**
   * Used for diplaying the publishing status of the project
   * @returns Component
   */
  function getStatusPill() {
    if (project.publishStatus === "under review") {
      return (
        <span data-cy={"pill-" + project.title} className="whitespace-nowrap inline-flex items-center h-6 rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800 dark:bg-yellow-300 dark:text-yellow-900">
          Under Review
        </span>
      );
    }
    if (project.publishStatus === "published" && project.locked === true) {
      return (
        <span data-cy={"pill-" + project.title} className="whitespace-nowrap inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 dark:bg-green-300 dark:text-green-900">
          Published - Locked
        </span>
      );
    }
    if (project.publishStatus === "published") {
      return (
        <span data-cy={"pill-" + project.title} className="whitespace-nowrap inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 dark:bg-green-300 dark:text-green-900">
          Published
        </span>
      );
    }
    if (project.publishStatus === "draft") {
      return (
        <span data-cy={"pill-" + project.title} className="whitespace-nowrap inline-flex items-center rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700 dark:bg-blue-300 dark:text-blue-900">
          Draft
        </span>
      );
    }
    if (project.publishStatus === "rejected") {
      return (
        <span data-cy={"pill-" + project.title} className="whitespace-nowrap inline-flex items-center rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-700 dark:bg-red-300 dark:text-red-900">
          Rejected
        </span>
      );
    }
  }
  

  return (
    <>
    <div
      className="relative block p-8 overflow-hidden border border-gray-200 rounded-xl shadow mb-5 dark:bg-gray-800 dark:border-gray-700"
      key={project.id || project.PK}
    >
      <span className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 via-blue-500 to-blue-600"></span>
      <div className="flex justify-between mb-1">
        {getStatusPill()}
        <Menu as="div" className="relative inline-block text-right">
          <div>
            <Menu.Button
              data-cy={project.title + "-options"}
              className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
            >
              <span className="sr-only">Options dropdown</span>
              <HiOutlineDotsHorizontal className="flex-shrink-0 -mr-1 ml-1 h-6 w-6 text-gray-400 group-hover:text-gray-500" />
            </Menu.Button>
          </div>
          <Transition
            as="div"
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="z-40 origin-top-right absolute right-0 mt-0 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:border dark:border-gray-700">
              <div className="py-1 " data-cy="options">
                <>
                  {(project.DOI === "" && project.publishStatus === "published") &&
                    <Menu.Item>
                      <button
                        className="w-full"
                        data-cy="request-doi"
                        onClick={() => {
                          setOpenDOIModal(true);
                        }}
                      >
                        <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700">
                          Request DOI
                        </p>
                      </button>
                    </Menu.Item>
                  }
                  {((userProfile.edit_locked !== "true" && !project.locked) || userProfile.is_staff === true || userProfile.is_staff === "true") && (
                    <Menu.Item>
                      {project.publishStatus === 'rejected' ? (
                        <button
                          className="w-full"
                          data-cy="resubmit-project"
                          onClick={() => history.push("/EditProject" + "?projectID=" + project.id)}
                        >
                          <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700">
                            Resubmit
                          </p>
                        </button>
                      ) : (
                        <button
                          className="w-full"
                          data-cy="edit-project"
                          onClick={() => history.push("/EditProject" + "?projectID=" + project.id)}
                        >
                          <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700">
                            Edit
                          </p>
                        </button>
                      )}
                    </Menu.Item>
                  )}
                  <Menu.Item>
                    <button
                      className="w-full"
                      data-cy="delete-project"
                      onClick={() => {
                        setProjectToDelete(project);
                        setOpenDeleteModal(true)  
                      }}
                    >
                      <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700">
                        Delete
                      </p>
                    </button>
                  </Menu.Item>
                  <Menu.Item>
                    <button
                      className="w-full"
                      data-cy="add-visualization"
                      onClick={() => (window.location.href = '/visualization')}
                    >
                      <p className="text-right mb-0 text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700">
                        Add Visualization
                      </p>
                    </button>
                  </Menu.Item>
                </>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      <div className="justify-between flex">
        <div>
          <a
            onClick={() => {
              window.open("/metadata-display/" + project.id);
            }}
          >
            <h5 className="hover:underline text-xl font-semibold text-gray-900 dark:text-white">
              {project.title}
            </h5>
          </a>
        </div>
      </div>

      <div className="mt-4 sm:pr-8">
        <p className="text-sm text-gray-500 dark:text-gray-400">{truncateString(project.abstract, 230)}</p>
      </div>

      <dl className="flex mt-6">
        <div className="flex flex-col-reverse">
          <dd className="text-xs text-gray-500 dark:text-gray-400">{project.publishedAt ? new Date(project.publishedAt).toLocaleDateString(undefined, { year:"numeric", month:"short", day:"numeric"}) : 'N/A'}</dd>
          <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">Published</dt>
        </div>

        {/* <div className="flex flex-col-reverse ml-3 sm:ml-6">
          <dd className="text-xs text-gray-500">
            {JSON.parse(project.stakeholders).filter(stakeholder => stakeholder.role === "Publisher")[0].name}
          </dd>
          <dt className="text-sm font-medium text-gray-600">Published By</dt>
        </div> */}
      </dl>
    </div>
    <RequestDOIModal openDOIModal={openDOIModal} setOpenDOIModal={setOpenDOIModal} requestDOI={requestDOI} project={project}/>
    <DeleteProjectModal openDeleteModal={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal} project={projectToDelete} removeProject={removeProject}/>
  </>
  );
}
